import React, { createContext } from 'react';
import io from 'socket.io-client';

export const SocketContext = createContext();

// operator, carrying the stage prefix and the nightly suffix of the page itself
function operatorUrl(hostname) {
  const stage = hostname.includes('stage02')
    ? 'stage02-'
    : hostname.includes('stage01') || hostname === 'localhost'
      ? 'stage01-'
      : '';
  const nightly = hostname.includes('nightly') ? '-nightly' : '';
  console.log(`https://${stage}operator${nightly}.vpfscandinavia.com`);

  return `https://${stage}operator${nightly}.vpfscandinavia.com`;
}

const SocketProvider = ({ children }) => {
  const hostname = window.location.hostname;
  var socket;
  var socketPW;
  var socketReport;

  socket = io(operatorUrl(hostname));

  if (hostname === 'localhost' || hostname.includes('stage01')) {
    socketPW = io('https://stage01-powerbingo.vpfscandinavia.com');
    socketReport = io('https://stage01-rapporter.vpfscandinavia.com');
  } else if (hostname.includes('stage02')) {
    socketPW = io('https://stage02-powerbingo.vpfscandinavia.com');
    socketReport = io('https://stage02-rapporter.vpfscandinavia.com');
  } else {
    socketPW = io('https://powerbingo.vpfscandinavia.com');
    socketReport = io('https://rapporter.vpfscandinavia.com');
  }

  console.log(`[socket] operator ${operatorUrl(hostname)}`);

  return (
    <SocketContext.Provider value={{ socket, socketPW, socketReport }}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
